import type { SVGProps } from "react";

const Microsoft = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 23 23">
    <path d="M1 1h10v10H1z" fill="#F25022" />
    <path d="M12 1h10v10H12z" fill="#7FBA00" />
    <path d="M1 12h10v10H1z" fill="#00A4EF" />
    <path d="M12 12h10v10H12z" fill="#FFB900" />
  </svg>
);

export { Microsoft };
